<!--
 * @Author: your name
 * @Date: 2021-01-05 18:27:54
 * @LastEditTime: 2021-04-07 10:13:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\LoadingPage.vue
-->
<template>
  <div class="loading" @click="cancelLoading" @touchstart="cancelLoading">
    <div class="loadingbg"></div>
    <img class="loadingIcon" :src="loadingGif" />
    <div
      class="progress-container"
      v-show="isLoading && !isReady && !isWaitting"
    >
      <div ref="msg" class="loadingText">欢迎进入，请稍等...</div>
      <div class="loadingContainer">
        <div class="loadingBar"></div>
      </div>
      <div class="loadingNumber">-1%</div>
    </div>
    <!-- <div class="waitting" v-show="isWaitting">点击进入</div> -->
    <img
      src="../../assets/img/icon/enter-button.png"
      class="waitting"
      v-show="isWaitting && isShowIcon && isShowWelcomeBtn"
    />
    <div class="copyright" v-show="!isLoading">三川田技术支持</div>
  </div>
</template>

<script>
import { Events } from "./Events";
import * as Utils from "./Utils";

export default {
  name: "loadingPage",
  components: {},
  props: {},
  data() {
    return {
      isLoading: false,
      isReady: false,
      isWaitting: false,
      isShowIcon: true,
      isShowWelcomeBtn: true,
      loadingGif: require("../../assets/img/loading/loading-default.gif"),
    };
  },
  methods: {
    //loading相关
    async init(setting, callback = null) {
      const ua = Utils.getPlatform();
      // loading GIF 加载
      if (setting.isUploadLoading && setting.loadingUrl !== "") {
        this.loadingGif = setting.loadingUrl;
      }

      // loading 文字
      if (setting.isShowCoverText) {
        this.$refs.msg.textContent =
          !setting.modelCoverText || setting.modelCoverText === ""
            ? setting.modelName
            : setting.modelCoverText;
      }
      await Utils.waitFor(1);
      this.waitForInput = setting.isStopLoadingPage;

      if (ua.platform !== "pc") {
        this.isShowWelcomeBtn = !!setting.isShowMobileButton
        // 检测到移动端了
        if (setting.isMobileBg) {
          // 如果有加载图那OK
          document.getElementsByClassName("loadingbg")[0].className =
            "loadingbg withM";
          const url = setting.mobileBg;
          document.getElementsByClassName(
            "withM"
          )[0].style.background = `url(${url})`;
          document.getElementsByClassName("withM")[0].style.backgroundPosition =
            "center";
          document.getElementsByClassName("withM")[0].style.backgroundSize =
            "cover";
          document.getElementsByClassName("loadingIcon")[0].style.display =
            "none";
        } else {
          // 如果没有加载图 默认给出白底+gif图
        }
      } else {
        this.isShowWelcomeBtn = !!setting.isShowPCButton
        // 检测到非移动端，则按PC来
        if (setting.isPcBg) {
          // 如果有加载图那OK
          document.getElementsByClassName("loadingbg")[0].className =
            "loadingbg withP";
          const url = setting.pcBg;
          document.getElementsByClassName(
            "withP"
          )[0].style.background = `url(${url})`;
          document.getElementsByClassName("withP")[0].style.backgroundPosition =
            "center";
          document.getElementsByClassName("withP")[0].style.backgroundSize =
            "cover";
          document.getElementsByClassName("loadingIcon")[0].style.display =
            "none";
        } else {
          // 如果没有加载图 默认给出白底+gif图
        }
      }

      this.e = (ev) => {
        if (ev.source !== window.parent) return;
        let data = ev.data;
        if (data.type === Events.SetWelcomeBtn) {
          this.isShowIcon = !!data.msg.isShow;
        }
        window.removeEventListener("message", this.e);
        this.e = undefined;
      };
      window.addEventListener("message", this.e);
      this.isLoading = true;
      this.onContinueCallback = callback;
      parent.postMessage({ type: Events.GetMessageReady, msg: {} }, "*");
    },

    finishLoading() {
      this.isReady = true;

      if (this.isShowWelcomeBtn) {
        this.isWaitting = true
        return
      }
      this.cancelLoading();
    },

    async cancelLoading() {
      if (!this.isReady) return;
      this.isReady = false;
      let loading = document.getElementsByClassName("loading")[0];
      if (loading.className === "loading withP") {
        loading.className = "loading-end withP";
      } else if (loading.className === "loading withM") {
        loading.className = "loading-end withM";
      } else {
        loading.className = "loading-end";
      }
      //等待渐变动画
      try {
        await Utils.waitFor(100);
        if (this.onContinueCallback) this.onContinueCallback();
      } catch (err) {}
      await Utils.waitFor(1200);
      document.getElementsByClassName("loading-end")[0].style.display = "none";
      this.$emit(Events.CancelLoading);
    },
    loadingTo(number) {
      document.getElementsByClassName("loadingBar")[0].style.width =
        number + "%";
      document.getElementsByClassName("loadingNumber")[0].innerHTML =
        number + "%";
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style scoped>
/*loading*/
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}

.loadingbg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
}

.withP {
  background-position: center;
  background-size: cover;
  animation: fadein 1s, scaleBIG 5s forwards;
}

.withM {
  background-position: center;
  background-size: cover;
  animation: fadein 1s, scaleBIG 5s forwards;
}

.loading-end {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999999999999;
  opacity: 1;
  animation: 1.2s fadeout 0.5s forwards;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes scaleBIG {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}

.progress-container {
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  bottom: 7%;
}

.loadingIcon {
  position: relative;
  bottom: 13.5%;
}

.loadingText {
  font-family: MicrosoftYaHei;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #fff;
  margin-top: 0;
}

.waitting {
  position: absolute;
  bottom: 76px;
  /* width: auto; */
  height: 37px;
  /* margin-bottom: 76px; */
  /* padding:0 20px 0 25px; */
  /* font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 5px;
  color: #4B529C; */
  text-align: center;
  /* border-radius: 5px;
  border: #C6D2E4 solid 1px;
  background-image: linear-gradient(#FFFFFF, #D9E8FF) */
}

.copyright {
  display: inline-block;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #000000;
  opacity: 0.4;
  position: absolute;
  bottom: 5%;
}

.loadingContainer {
  width: 80%;
  height: fit-content;
  background-color: black;
  border-radius: 3.5px;
  margin-top: 18px;
}

.loadingBar {
  height: 3px;
  width: 50%;
  border-radius: 3.5px;
  border: solid 2px #2279f1;
  box-sizing: border-box;
}

.loadingNumber {
  font-family: MicrosoftYaHei;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #fff;
  margin-top: 18px;
}

@media screen and (max-width: 768px) {
  /*loading-mobile*/
  .progress-container {
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    bottom: 5%;
  }

  .loadingIcon {
    width: 84px;
    height: 84px;
    object-fit: cover;
    position: relative;
    bottom: 30%;
  }

  .loadingText {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    margin-bottom: -19px;
  }

  .loadingContainer {
    width: 80%;
    height: fit-content;
    background-color: black;
    border-radius: 2px;
    margin: 0;
  }

  .loadingBar {
    height: 3px;
    width: 50%;
    border-radius: 2px;
    border: solid 2px #2279f1;
    box-sizing: border-box;
  }

  .loadingNumber {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    margin-top: -19px;
  }
}
</style>
